
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bioresonance",
      function () {
        return require("private-next-pages/bioresonance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bioresonance"])
      });
    }
  